import React from 'react';
import { Facebook, Twitter, Instagram, Music, Ghost } from 'lucide-react';

export const SOCIAL_LINKS = [
  { Icon: Facebook, title: 'فيسبوك', url: 'https://facebook.com/hololdigital' },
  { Icon: Twitter, title: 'تويتر (X)', url: 'https://twitter.com/hololdigital' },
  { Icon: Instagram, title: 'انستغرام', url: 'https://instagram.com/hololdigital' },
  { Icon: Music, title: 'تيك توك', url: 'https://tiktok.com/@hololdigital' },
  { Icon: Ghost, title: 'سناب شات', url: 'https://snapchat.com/add/hololdigital' }
];

export const FOOTER_LINKS = {
  quickLinks: [
    { name: 'الرئيسية', href: '/' },
    { name: 'عن الشركة', href: '/about' },
    { name: 'خدماتنا الشاملة', href: '/services' },
    { name: 'المدونة', href: '/#blog' },
    { name: 'تقييم جاهزية التأسيس', href: '/company-setup-readiness-assessment' },
    { name: 'نجاحات التأسيس', href: '/#partners' },
    { name: 'احجز استشارة مجانا', href: '/#contact' },
    { name: 'تسجيل دخول المسئول', href: '/admin/login' }
  ],
  businessSetupLinks: [
    { name: 'تأسيس شركة في السعودية', href: '/company-setup-saudi-arabia' },
    { name: 'استخراج سجل تجاري في السعودية', href: '/commercial-registration-saudi-arabia' },
    { name: 'تجديد سجل تجاري في السعودية', href: '/commercial-registration-renewal-saudi-arabia' },
    { name: 'تعديل سجل تجاري في السعودية', href: '/commercial-registration-amendment-saudi-arabia' },
    { name: 'استخراج تراخيص تجارية في السعودية', href: '/commercial-licenses-saudi-arabia' },
    { name: 'إدارة التراخيص الحكومية للشركات', href: '/government-licenses-management-saudi-arabia' },
    { name: 'استشارات تأسيس الشركات للأجانب', href: '/foreign-business-setup-consulting-saudi-arabia' },
    { name: 'استشارات تأسيس الأعمال', href: '/business-setup-consulting-saudi-arabia' },
    { name: 'استخراج ترخيص وزارة الاستثمار MISA', href: '/misa-license-saudi-arabia' },
    { name: 'تصنيف المقاولين بالسعودية', href: '/contractor-classification-saudi-arabia' },
    { name: 'تأسيس شركة ذات مسؤولية محدودة', href: '/llc-setup-saudi-arabia' },
    { name: 'شطب سجل تجاري في السعودية', href: '/commercial-registration-cancellation-saudi-arabia' },
    { name: 'خدمات قوى ومقيم ومدد للمنشآت', href: '/qiwa-muqeem-madad-services-saudi-arabia' },
    { name: 'خدمات الزكاة والضريبة (ZATCA)', href: '/zatca-services-saudi-arabia' },
    { name: 'حماية الأجور واللوائح التنظيمية', href: '/wage-protection-and-internal-regulations-saudi-arabia' },
    { name: 'تأسيس شركة في الرياض', href: '/business-setup-riyadh' },
    { name: 'تأسيس شركة في جدة', href: '/business-setup-jeddah' },
    { name: 'تأسيس شركة في الدمام', href: '/business-setup-dammam' },
    { name: 'تأسيس شركة في الخبر', href: '/business-setup-khobar' },
    { name: 'تأسيس شركة أجنبية في السعودية', href: '/foreign-investor-setup' },
    { name: 'تأسيس شركة أجنبية (الشروط والخطوات)', href: '/foreign-investor-setup' },
    { name: 'أداة تقييم جاهزية التأسيس', href: '/company-setup-readiness-assessment' },
    { name: 'دعم رواد الأعمال', href: '/entrepreneur-support' }
  ],
  blogLinks: [
    { name: 'فتح شركة في السعودية للمقيمين', href: '/blog/%D9%81%D8%AA%D8%AD-%D8%B4%D8%B1%D9%83%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9-%D9%84%D9%84%D9%85%D9%82%D9%8A%D9%85%D9%8A%D9%86' },
    { name: 'شروط تأسيس شركة للأجانب', href: '/blog/%D8%B4%D8%B1%D9%88%D8%B7-%D8%AA%D8%A3%D8%B3%D9%8A%D8%B3-%D8%B4%D8%B1%D9%83%D8%A9-%D9%81%D9%8A-%D8%A7%D9%84%D8%B3%D8%B9%D9%88%D8%AF%D9%8A%D8%A9-%D9%84%D9%84%D8%A3%D8%AC%D8%A7%D9%86%D8%A8' },
    { name: 'فتح شركة في السعودية (التكلفة والشروط)', href: '/blog/open-company-saudi-arabia-cost-foreign-investment' },
    { name: 'كيفية استخراج سجل تجاري جديد', href: '/blog/how-to-issue-new-commercial-registration-saudi-arabia' },
    { name: 'شروط استخراج السجل التجاري', href: '/blog/commercial-registration-requirements-saudi-arabia' },
    { name: 'طريقة تجديد السجل التجاري', href: '/blog/how-to-renew-commercial-registration-saudi-arabia' },
    { name: 'خطوات تأسيس شركة في السعودية', href: '/blog/steps-of-saudi-company-formation-for-entrepreneurs' },
    { name: 'الفرق بين السجل الرئيسي والفرعي', href: '/blog/difference-between-main-and-branch-commercial-register' }
  ]
};

export const CONTACT_INFO = {
  phone: '+966 566 900 924',
  email: 'info@hololdigital.com',
  address: 'حفر الباطن، المملكة العربية السعودية'
};

export const LEGAL_CONTENT = {
  privacy: (
    <div className="space-y-6">
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">1. مقدمة</h3>
        <p>تلتزم شركة الحلول الرقمية بحماية خصوصيتك وبياناتك الشخصية بما يتوافق مع "نظام حماية البيانات الشخصية" (PDPL) الصادر في المملكة العربية السعودية. توضح هذه السياسة كيفية جمع واستخدام وحماية معلوماتك.</p>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">2. البيانات التي نجمعها</h3>
        <p>نقوم بجمع البيانات اللازمة لتقديم خدماتنا، والتي تشمل:</p>
        <ul className="list-disc pr-6 mt-2 space-y-1">
          <li>الاسم ومعلومات الاتصال (الهاتف، البريد الإلكتروني).</li>
          <li>بيانات الشركة والسجلات التجارية.</li>
          <li>المعلومات التقنية حول استخدام الموقع.</li>
        </ul>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">3. الغرض من المعالجة</h3>
        <p>تستخدم البيانات للأغراض التالية:</p>
        <ul className="list-disc pr-6 mt-2 space-y-1">
          <li>اتمام إجراءات تأسيس الشركات وإصدار التراخيص.</li>
          <li>التواصل معكم وتقديم الدعم الفني.</li>
          <li>تحسين جودة خدماتنا وتجربة المستخدم.</li>
        </ul>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">4. حقوقك</h3>
        <p>بموجب الأنظمة السعودية، يحق لك الوصول إلى بياناتك، وطلب تصحيحها، أو إتلافها، وكذلك سحب الموافقة على معالجتها في أي وقت.</p>
      </section>
    </div>
  ),
  terms: (
    <div className="space-y-6">
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">1. قبول الشروط</h3>
        <p>باستخدامك لهذا الموقع، فأنت توافق على الالتزام بالشروط والأحكام التالية، والأنظمة السارية في المملكة العربية السعودية.</p>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">2. الخدمات المقدمة</h3>
        <p>تعمل شركتنا كمزود لخدمات تأسيس الأعمال والاستشارات. نحن نبذل قصارى جهدنا لضمان دقة المعلومات، ولكن الإجراءات قد تخضع لتغييرات الأنظمة الحكومية.</p>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">3. حقوق الملكية الفكرية</h3>
        <p>جميع المحتويات، والشعارات، والبرمجيات في هذا الموقع هي ملك لشركة الحلول الرقمية، ويُمنع نسخها أو استخدامها دون إذن مسبق.</p>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">4. إخلاء المسؤولية</h3>
        <p>نحن غير مسؤولين عن أي تأخير خارج عن إرادتنا ناتج عن الإجراءات الحكومية أو المعلومات غير الدقيقة التي يقدمها العميل.</p>
      </section>
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">5. القانون الواجب التطبيق</h3>
        <p>تخضع هذه الشروط وتفسر وفقاً لأنظمة المملكة العربية السعودية، وأي نزاع يحل أمام المحاكم المختصة بالمملكة.</p>
      </section>
    </div>
  ),
  cookies: (
    <div className="space-y-6">
      <section>
        <h3 className="text-xl font-bold text-brand-dark mb-3">سياسة ملفات تعريف الارتباط</h3>
        <p>نستخدم ملفات تعريف الارتباط (Cookies) لتحسين تجربتك على موقعنا. تساعدنا هذه الملفات على:</p>
        <ul className="list-disc pr-6 mt-2 space-y-1">
          <li>حفظ تفضيلاتك وجعل تصفحك أسهل.</li>
          <li>تحليل حركة المرور وفهم كيفية استخدام الموقع.</li>
          <li>توفير محتوى يتناسب مع اهتماماتك.</li>
        </ul>
        <p className="mt-4">يمكنك التحكم في إعدادات ملفات تعريف الارتباط من خلال متصفحك، ولكن قد يؤثر تعطيلها على بعض وظائف الموقع.</p>
      </section>
    </div>
  )
};

